import type { TourDefinition } from '../training/tours';

/**
 * Тур трекера обліку часу (/time). Ідентифікатор для реєстрації: 'time-tracker'.
 * Цілі — атрибути data-tour у TimeLayout і сторінці трекера (features/time/tracker/*).
 */
export const TIME_TRACKER_TOUR_ID = 'time-tracker';

export const TIME_TRACKER_TOUR: Omit<TourDefinition, 'id'> = {
  title: 'Трекер часу',
  summary: 'Таймер і ручні записи, стандарт опису, записи тижня з редагуванням у рядку, покриття норми й перевірка якості.',
  missingHint: 'Відкрийте розділ «Облік часу» → «Трекер» — підказки прив’яжуться до таймера й записів тижня.',
  steps: [
    {
      id: 'nav',
      target: 'time-nav',
      title: 'Розділи обліку часу',
      body: 'Трекер — щоденний облік; «Табель» — тиждень для подання; «Звіти», «Розклад», «Відсутності», «Витрати». «Погодження» й «Бюджети» бачать керівники й ті, хто погоджує.',
      placement: 'bottom',
    },
    {
      id: 'bar',
      target: 'time-timer-bar',
      title: 'Таймер',
      body: 'Опишіть роботу за стандартом «об’єкт_дія в минулому часі» й прив’яжіть запис до задачі, проєкту часу чи справи. Одночасно працює один таймер: запуск нового зупиняє попередній. Запущений таймер видно у верхній панелі на будь-якому екрані — звідти його можна зупинити.',
      placement: 'bottom',
    },
    {
      id: 'mode',
      target: 'time-mode',
      title: 'Час уручну',
      body: 'Забули запустити таймер — додайте запис уручну: дата, початок і кінець або тривалість («1:30», «45 хв»). Обід і святкування не трекаються.',
    },
    {
      id: 'week',
      target: 'time-week-summary',
      title: 'Тиждень і табель',
      body: 'Обліковано проти місткості за графіком, покриття норми вашої ролі й стан табеля. Табель подають за тиждень; після подання записи змінюються лише після повернення чи за дозволом.',
    },
    {
      id: 'entries',
      target: 'time-entries',
      title: 'Записи тижня',
      body: 'Опис, прив’язку, проміжок і тривалість змінюйте просто в рядку: Enter — зберегти, Esc — скасувати. У меню «…» — продовжити, дублювати, розбити між проєктами.',
    },
    {
      id: 'quality',
      target: 'time-quality',
      title: 'Перевірка якості',
      body: 'Система позначає порожні описи, неприв’язані записи й записи в кошику, перекриття та записи понад норму. «Перевірити з ШІ» пропонує формулювання — застосовуєте їх ви.',
    },
  ],
};
